import { createContext, useCallback, useContext, useState } from "react";
import { ICityTaxAuto } from "../interfaces";
import { AxiosError } from "axios";
import { EmitError } from "../utils/EmitError";
import useAuth from "../hooks/useAuth";
import { Outlet } from "react-router-dom";
import CityTaxesAutoService from "../services/http/services/CityTaxesAutoService";

interface ICityTaxesAutoContext {
    cityTaxesAuto: Array<ICityTaxAuto>;
    loadCityTaxesAuto: (controller?: AbortController) => Promise<any>;
}
export const CityTaxesAutoContext = createContext({} as ICityTaxesAutoContext);

export function CityTaxesAutoProvider() {
    const [cityTaxesAuto, setCityTaxesAuto] = useState<Array<ICityTaxAuto>>([]);

    const { activeCity } = useAuth();

    const loadCityTaxesAuto = useCallback(async (abortController?: AbortController) => {
        const controller = abortController || new AbortController();

        try {
            const cityTaxesAutoList = await CityTaxesAutoService.listCityTaxesAuto(activeCity?.id!, controller.signal);

            setCityTaxesAuto(cityTaxesAutoList);
        } catch (err) {
            if (err instanceof AxiosError && err.name === 'CanceledError') {
                return;
            }

            EmitError(err, true, 'cityTaxesAuto_asdhashuidd');
        }

        return () => {
            controller.abort();
        }
    }, [activeCity]);

    return (
        <CityTaxesAutoContext.Provider value={{
            cityTaxesAuto, loadCityTaxesAuto
        }}>
            <Outlet />
        </CityTaxesAutoContext.Provider>
    )
}

export function useCityTaxesAutoContext() {
    return useContext(CityTaxesAutoContext);
}
